import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AccountPrivacy } from "@/components/AccountPrivacy";

export default function SettingsPage() {
  const { user } = useAuth();
  return (
    <div className="max-w-xl mx-auto space-y-5" data-testid="settings-page">
      <h1 className="font-display text-2xl font-extrabold">Einstellungen & Daten</h1>
      <AccountPrivacy />
      <p className="text-sm text-slate-500 text-center">Push, Newsletter, Ton und blockierte Mitglieder stellst du in <Link to={`/u/${user.user_id}`} data-testid="settings-profile-link" className="font-bold text-rose-600 hover:underline">deinem Profil</Link> ein.</p>
    </div>
  );
}
